import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("progress", {
  class: "progress is-small is-info",
  max: "100"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IndexForm = _resolveComponent("IndexForm")!

  return (_ctx.index)
    ? (_openBlock(), _createBlock(_component_IndexForm, {
        key: 0,
        index: _ctx.index,
        users: _ctx.users
      }, null, 8, ["index", "users"]))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}